import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@mantine/core';
const HelpTooltip = ({ children, ...props }) => {
    return (_jsx(Tooltip, { withArrow: true, position: "bottom", styles: { tooltip: { fontSize: '12px', opacity: 0.9 } }, ...props, children: children }));
};
export default HelpTooltip;
